import React from 'react';
import './About.css';

export default function About() {
  const points = [
    {
      title: "Des artistes triés sur le volet",
      text: "Chaque musicien est sélectionné pour son talent, son professionnalisme et son expérience scénique.",
    },
    {
      title: "Un service simple et rapide",
      text: "Trouvez l’artiste idéal en quelques clics, selon votre style, ville et type d’événement.",
    },
    {
      title: "Un accompagnement humain",
      text: "Notre équipe vous accompagne gratuitement pour vous aider à faire le bon choix.",
    },
  ];

  return (
    <section className="about-section">
      <h2 className="about-title">Pourquoi choisir nos musiciens ?</h2>
      <div className="about-cards">
        {points.map((point, index) => (
          <div key={index} className="about-card">
            <h3>{point.title}</h3>
            <p>{point.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
